<template>
  <div class="business-buy-button">
    <button-component
      v-if="userShouldLogout"
      data-test-id="logout"
      :is-cta="true"
      :event-category="eventCategory"
      :event-name="eventName || 'logout-modal'"
      @click="showModal = true"
    >
      {{ $t("cta") }}
    </button-component>
    <button-component
      v-else
      data-test-id="continue"
      :href="$options.startTeamPath"
      :open-signup="true"
      :data="{
        'login-path': $options.afterLoginPath,
        'signup-path': $options.afterSignupPath
      }"
      :event-category="eventCategory"
      :event-name="eventName || 'start-a-team'"
      :is-cta="true"
    >
      {{ $t("cta") }}
    </button-component>
    <logout-modal :show="showModal" @toggle="(show) => (showModal = show)" :i18n-key="translationKey" />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import ButtonComponent from "@/shared/button"
import LogoutModal from "@/pages/business/components/logout-modal"
import globals from "@/utils/globals"

const businessGlobals = globals.business || {}
const routes = globals.routes || {}

export default {
  name: "BuyButton",
  startTeamPath: routes.startTeamPath,
  afterSignupPath: businessGlobals.afterSignupPath,
  afterLoginPath: businessGlobals.afterLoginPath,
  components: {
    ButtonComponent,
    LogoutModal
  },
  props: {
    eventCategory: { type: String, default: "body-20210217-business_buy_button" },
    eventName: { type: String, default: null }
  },
  data() {
    return {
      showModal: false
    }
  },
  computed: {
    ...mapGetters([
      "isInB2bOrganisation",
      "isInB2cMultiUserPlan",
      "isB2cMultiUserPlanOwner",
      "isB2bOrganisationOwner",
      "isB2cMultiUserPlanMember",
      "isB2bOrganisationMember"
    ]),
    userShouldLogout() {
      return this.isInB2bOrganisation
    },
    translationKey() {
      if (this.isB2bOrganisationOwner) {
        return "teamOwner"
      } else if (this.isB2bOrganisationMember) {
        return "teamMember"
      } else {
        return "default"
      }
    }
  },
  mounted() {
    this.$store.dispatch("organisationInfo")
  },
  i18n: {
    messages: {
      en: {
        cta: "Buy now"
      },
      de: {
        cta: "Jetzt kaufen"
      }
    }
  }
}
</script>

<style lang="scss">
.business-buy-button {
  width: 100%;
}
</style>
